import React, { useState, useEffect } from 'react';
import './completeSyllabus.css'
import C2wCourseCount from '../../../../common/C2wHome/courses/count';
import C2wCourseTopicNameCard from '../../../../common/C2wHome/courseDetails/courseTopicNameCard';
import C2wCourseDetailsTopicCard from '../../../../common/C2wHome/courseDetails/courseDetailsTopicCard';
import C2wCourseDetailCardMobile from '../../../../common/C2wHome/courseDetails/courseDetailCardMobile';

function C2wCompleteSyllabus( { courseData = null} ) {
    
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    useEffect(() => {
      const handleResize = () => {
        setWindowWidth(window.innerWidth);
      };
  
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
 
    /**
 * @constant renderedCourseCount
 * @author Vishal Lohbande
 * @description Maps over the `syllabusContentCountArray` inside `courseData` to render
 * a list of `C2wCourseCount` components, each receiving an `obj` prop with the corresponding data.
 * 
 * @returns {JSX.Element[]} Array of `C2wCourseCount` components
 * 
 * Usage:
 * Used to display counts or stats related to the course syllabus.
 */
    const renderedCourseCount = courseData?.syllabusContentCountArray.map((obj, index) => {
        return <C2wCourseCount obj={obj} />
    })

    /**
 * @function handleDetails
 * @param {number} index - The index of the item to select
 * @author Vishal Lohbande
 * @description
 * - Updates the `selectedIndex` state with the given `index`.
 * - Typically used to handle selection or highlight of an item based on user interaction.
 *
 * Usage:
 * - Called when an item is clicked or selected to update the UI accordingly.
 */
    const handleDetails = (index) => {
        setSelectedIndex(index);
        console.log(index)
    };

    /**
 * @function handleDetailsFlag
 * @param {number} index - The index to set as selected
 * @author Vishal Lohbande
 * @description
 * - Updates the `selectedIndex` state with the provided `index`.
 * - Used to toggle or set the currently active or selected item based on the index.
 *
 * Usage:
 * - Triggered by user interaction or programmatic events to change the selected item.
 */
    const handleDetailsFlag = (index) => {
        console.log(index)
        setSelectedIndex(index)
    }
    
/**
 * @constant renderedTopicsCards
 * @author Vishal Lohbande
 * @description Maps over the `topicTitlesArray` inside `courseData` to render
 * a list of topic cards. It conditionally renders either `C2wCourseTopicNameCard`
 * for desktop (window width > 620) or `C2wCourseDetailCardMobile` for mobile devices.
 * 
 * Each card receives the topic data (`obj`), index, selection state, and click handlers
 * to update the currently selected topic index.
 * 
 * This ensures a responsive UI adapting to different screen sizes.
 * 
 * @returns {JSX.Element[]} Array of course topic cards components
 * 
 * Usage:
 * Used to display selectable course topics, with different UI for desktop and mobile.
 */
    const [selectedIndex, setSelectedIndex] = useState(0);
    const renderedTopicsCards = courseData?.topicTitlesArray.map((obj, index) => {
        return windowWidth > 620 ? (
            <C2wCourseTopicNameCard
                key={index}
                obj={obj}
                index={index}
                isSelected={selectedIndex === index}
                onClick={() => handleDetails(index)}
            />
        ) : (
            <C2wCourseDetailCardMobile
                key={index}
                obj={obj}
                topicIndex={index}
                isSelectedIndex={selectedIndex === index}
                handleIsIndexFlag={() => handleDetailsFlag(index)}
            />
        );
    });

    

    return (
        windowWidth > 620 ? (
        <div className='C2wCompleteSyllabus_ctn'>
            <div className='C2wCompleteSyllabus_heading_ctn'>
                <div className='C2wCompleteSyllabus_heading'>{'Complete Syllabus'}</div>
                <div className='C2wCompleteSyllabus_countHld'>
                    {renderedCourseCount}
                </div>
            </div>
            <div className='C2wCompleteSyllabus_topics_ctn'>
                <div className='C2wCompleteSyllabus_topics_card_hdl'>
                    <div className='C2wCompleteSyllabus_topics_card_hdl_scroller'>
                        {renderedTopicsCards}
                    </div>
                </div>
                <div className='C2wCompleteSyllabus_topics_card_details_hld'>
                    <div className='C2wCompleteSyllabus_topics_card_details_hld_scroller'>
                        <div className='C2wtopicsHeading_card_details_ctn'>
                            <div className='highLighCount'>{'All'}<span>{courseData?.topicTitlesArray[selectedIndex]?.contentCount?.allCount}</span></div>
                            <div className='highLighCount'>{'Lectures'}<span>{courseData?.topicTitlesArray[selectedIndex]?.contentCount?.lectureCount}</span></div>
                            <div className='highLighCount'>{'Assignments'}<span>{courseData?.topicTitlesArray[selectedIndex]?.contentCount?.assignmentCount}</span></div>
                            <div className='highLighCount'>{'Quiz'}<span>{courseData?.topicTitlesArray[selectedIndex]?.contentCount?.quizCount}</span></div>
                        </div>
                        { courseData?.topicTitlesArray[selectedIndex] && courseData?.topicTitlesArray[selectedIndex]?.subTopicArray?.map((obj,i) => (
                        <C2wCourseDetailsTopicCard obj={obj} i={i} selectedIndex={selectedIndex}  />
                    ))}
                    </div>
                </div>
            </div>
        </div>
    )
    : (
        <div className='C2wCompleteSyllabus_ctn'>
            <div className='C2wCompleteSyllabus_heading_ctn'>
                <div className='C2wCompleteSyllabus_heading'>{'Complete Syllabus'}</div>
                <div className='C2wCompleteSyllabus_countHld'>
                    {renderedCourseCount}
                </div>
            </div>
            <div className='C2wCourseDetailCard_mobile_ctn'>
                {renderedTopicsCards}
            </div>
        </div>
    )
)
}

export default C2wCompleteSyllabus
